<script lang="ts">
	import { fade } from "svelte/transition"
	import MobileOtherLink from "./MobileOtherLink.svelte"
	import { SmallPlusIcon } from "luxedo-icons"
	import { MobileOtherLinksController } from "./MobileOtherLinksController.svelte"
	import MobileLinkArrow from "./MobileLinkArrow.svelte"

	// account overlay, report issue, content solutions, whats new

	interface Props {
		controller: MobileOtherLinksController
	}

	let { controller }: Props = $props()

	let { isOpen } = $derived(controller.ctx)
	let anchorElem: HTMLDivElement = $state()

	function handleTouchStart(e: TouchEvent) {
		const { clientX, clientY } = e.touches[0]
		const elems = document.elementsFromPoint(clientX, clientY)
		if (!elems.includes(anchorElem)) controller.close()
	}
</script>

<div class="mobile-other-links-anchor" bind:this={anchorElem}>
	{#if isOpen}
		<div class="mobile-other-links-bg" onclick={controller.close}></div>
		<div class="mobile-other-links" in:fade={{ duration: 150 }} out:fade={{ duration: 150 }}>
			{#each Object.entries(controller.LINKS) as [title, action]}
				<MobileOtherLink {title} {action} close={controller.close} />
			{/each}
			<button class="close-links-button icon small" onclick={controller.close}>
				<SmallPlusIcon />
			</button>
		</div>
		<div class="mobile-arrow-container">
			<MobileLinkArrow />
		</div>
	{/if}
</div>

<style>
	.mobile-other-links-anchor {
		z-index: 10;
		position: absolute;
		bottom: 5rem;
		right: 0rem;
	}

	.mobile-other-links-bg {
		position: fixed;
		top: 0;
		left: 0;
		width: 100dvw;
		height: 100dvh;
		z-index: 0;
	}

	.mobile-other-links {
		position: fixed;
		z-index: 1;
		background-color: var(--color-bg);
		width: calc(100dvw - 3rem);
		backdrop-filter: blur(8px);
		padding: 1rem;
		bottom: 5.5rem;
		right: 1.5rem;
		border-radius: var(--br);
		display: flex;
		flex-direction: column;
	}

	.close-links-button {
		position: absolute;
		top: 0.25rem;
		right: 0.25rem;
	}

	button.close-links-button :global(svg) {
		width: 1rem;
		rotate: 45deg;
	}

	button.close-links-button :global(.svg-stroke) {
		stroke: var(--color-text);
	}

	.mobile-arrow-container {
		position: relative;
		bottom: -1.25rem;
		right: 1.25rem;
	}
</style>
